import { Timestamp } from "firebase-admin/firestore";
import { jsPDF } from "jspdf";
import { DocumentSpec, SalePDFProps } from "../../_importDocs";

// Variants
import defaultSaleSummary from "./variants/default";
import machinerySaleSummary from "./variants/machinery";

// Extend jsPDF type to include 'previousAutoTable'
declare module "jspdf" {
  interface jsPDF {
    previousAutoTable?: {
      finalY?: number;
      [key: string]: any;
    };
  }
}

const SaleSummaryNewSpec: DocumentSpec = {
  // must be unique
  id: "sale-summary",

  objectType: "sale",

  // displayed to the user
  name: "Sale Summary",

  // when the PDF is downloaded, this function is called to generate the filename
  getFilename: (props) => {
    let { sale, lots } = props;

    let sanitisedSaleName = sale.name.replace(/[^a-z0-9]/gi, "_");
    // replace more than one underscore with a single underscore
    sanitisedSaleName = sanitisedSaleName.replace(/_+/g, "_");

    let filesafeDate = (sale.startsAt as Timestamp)
      .toDate()
      .toISOString()
      .split("T")[0]
      .replace(/[^a-z0-9]/gi, "-");

    return `Summary ${filesafeDate} ${sanitisedSaleName}`;
  },

  // unused for sales...
  isAvailableFor: () => {
    return true;
  },

  // the document template
  jsPDF: (props: SalePDFProps) => {
    const { sale } = props;

    const { superTypes } = sale;

    const doc = new jsPDF({
      putOnlyUsedFonts: true,
      compress: true,
      unit: "mm",
      format: "a4",
    });

    if (superTypes.includes("Machinery")) {
      return machinerySaleSummary(doc, props);
    }

    return defaultSaleSummary(doc, props);
  },
};

export default SaleSummaryNewSpec;
